import React, { Component } from "react";
import "./Home.css";
import { Link } from "react-router-dom";
import Header from "../header/Header";
import Footer from "../footer/Footer";
const welcomePic = require("../../assets/images/Watson.png");

import { Player, ControlBar, PlayToggle} from 'video-react';
let iotcanada1 = 'https://demo-iotcanada.s3.ca-tor.cloud-object-storage.appdomain.cloud/iotcanada1.mov'
let iotcanada2 = 'https://demo-iotcanada.s3.ca-tor.cloud-object-storage.appdomain.cloud/iotcanada2.mov'

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHome: true,
      isInspectr: false
    };
  }

  render() {
    return (
      <div className="home-header">
        <Header />

        <div className="containerbanner">
          <img className="png-image" src={welcomePic} />
          <div className="title-text" />
        </div>

        <div className="aboutus">
          <div className="aboutus-flex-container">
            <div className="about-text-left">
              <div className="mainheader2">About Us</div>
              <p className="desktop-text">
                With the advancement in connected technology, IoT is becoming
                more a part of our everyday lives. It is changing the way we
                operate and conduct business. <br /><br />

                We, <b>Edge, AI & Connected Operations</b> team of IBM Consulting of IBM Canada, leverages IoT data through
                AI and cognitive technologies, deployed onto Cloud, Edge and Hybrid, enables our customers to find greater insights to
                improve businesses.
              </p>

              <p className="mobile-text">
                IoT is becoming more a part of our everyday lives, through
                cognitive computing it enables us to find greater insights to
                improve business operations.

                We, <b>Edge, AI & Connected Operations</b> team of IBM Consulting of IBM Canada, leverages IoT data through
                AI and cognitive technologies, deployed onto Cloud, Edge and Hybrid, enables our customers to find greater insights to
                improve businesses.
              </p>
            </div>
          </div>
        </div>

        <div className="solutions">
          <div className="mainheader">Solutions</div>
          <div className="click-link">
          <div className="sub-header-mobile">IBM Edge AI Platform (IoTVision)</div>
            <div className="solution-flex-container">
              <div className="inspectrvid">
                <Player ref="player">
                  <source src={iotcanada1} />
                </Player>
              </div>
              <a className="about-text-inspect" href="/inspectr">
                <div className="header2">IBM Edge AI Platform (IoTVision)</div>
                Built by the <b><i>Edge, AI & Connected Operation IoT team (formerly Watson IoT Canada) of IBM Canada</i></b>, <br />
                <b>IoTVision</b> is a proven visual recognition platform that can be used to <i><b>design, build, deploy, maintain  
                Edge AI focused solution </b></i>at any level of AI operation maturity, even across levels.<br /><br />
                It is an AI solution development framework for building and running <b>custom AI Solutions at scale</b>.
                Proven with customer engagements, it can comprehend, analyze, and provide
                insights of the content within images using custom built AI models and pipielines.
                <div id="demobutton">
                  <button className="demo-button">See Demos</button>
                </div>
              </a>
            </div>
          </div>

          <div className="separator" width="100%" />

          <div className="click-link">
          <div className="sub-header-mobile">IBM Edge Computing</div>
            <div className="solution-flex-container-2">
              <a className="about-text-trace" href="https://www.ibm.com/cloud/blog/what-is-multi-access-edge-computing">
                <div className="header2">Edge Computing with AI & IoT</div>
                <b>Edge Computing</b> and <b>Multi-Access Edge Computing Platform (MEC)</b> on 5G,
                are the distributed computing frameworks that bring enterprice applications
                closer to data sources such IoT devices, local edge servers,
                5G computing networks, etc to run AI and Analystics for 
                Near Real-time processing for faster insignts for operations
                critical applications.<br /> <br />  
                For more details on IBM offerings, check out the offereings from IBM. 
                <div id="demobutton">
                  <button className="demo-button">Learn more on IBM Edge Computing</button>
                </div>
              </a>
              <div className="inspectrvid">
                <Player ref="player">
                  <source src={iotcanada2} />
                  <ControlBar autoHide={true} disableDefaultControls={true}>
                      <PlayToggle />
                  </ControlBar>
                </Player>
              </div>
            </div>
          </div>
        </div>

        <div id="mybutton">
          <button className="contactbutton">Contact</button>
        </div>

        <Footer />
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// src/components/home/Home.js